import React from "react";
import Navbar from "@/components/Navbar";
import { Link } from "react-router-dom";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-white" data-testid="legal-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-4">
          Legal · Jingle Hooks
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tighter leading-tight mb-4">
          {title}
        </h1>
        <div className="text-sm text-zinc-500 mb-12 font-mono uppercase tracking-widest">
          Last updated · {updated}
        </div>
        <div className="prose prose-zinc max-w-none prose-headings:font-display prose-headings:tracking-tight prose-h2:text-2xl prose-h2:font-semibold prose-h2:mt-12 prose-h2:mb-4 prose-p:leading-relaxed prose-p:text-zinc-700 prose-a:text-[#FF4500] prose-a:no-underline hover:prose-a:underline prose-strong:text-black">
          {children}
        </div>
        <div className="mt-16 pt-8 border-t border-black/10 text-sm text-zinc-500">
          Questions? Email us at <a href="mailto:support@jinglehooks.com" className="text-[#FF4500] hover:underline font-semibold">support@jinglehooks.com</a> or visit our <Link to="/" className="text-[#FF4500] hover:underline font-semibold">homepage</Link>.
        </div>
      </main>
    </div>
  );
}
